import * as actionTypes from '../../Action/actionTypes';

const initialState = {
  table_data: {
    columns: [
      {
        label: 'Floor Name',
        field: 'desc',
        sort: 'asc'
      },
      {
        label: 'Floor Level',
        field: 'level',
        sort: 'asc'
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'asc'
      },
      {
        label: 'Floor Color',
        field: 'color',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
    new_floor_columns: [
      {
        label: 'Floor Name',
        field: 'desc',
        sort: 'asc'
      },
      {
        label: 'Floor Level',
        field: 'level',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
    rows: []
  },
  viewAllTable_data: {
    columns: [
      {
        label: 'Building Name',
        field: 'building',
        sort: 'asc'
      },
      {
        label: 'Location',
        field: 'location',
        sort: 'asc'
      },
      {
        label: 'View',
        field: 'view',
        sort: 'asc'
      },
      {
        label: 'Code',
        field: 'code',
        sort: 'asc'
      },
      {
        label: 'Level',
        field: 'level',
        sort: 'asc'
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'asc'
      },
      {
        label: 'Floors',
        field: 'floor',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
    manage_building_columns: [
      {
        label: 'Building Name',
        field: 'building',
        sort: 'asc'
      },
      {
        label: 'Branch Name',
        field: 'branch',
        sort: 'asc'
      },
      // {
      //   label: 'View',
      //   field: 'view',
      //   sort: 'asc'
      // },
      // {
      //   label: 'Code',
      //   field: 'code',
      //   sort: 'asc'
      // },
      {
        label: 'Level',
        field: 'level',
        sort: 'asc'
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'asc'
      },
      {
        label: 'Floors',
        field: 'floor',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
    rows: []
  },
  floors: [],
  locations: [],
  floorViewTable_data: {
    columns: [
      {
        label: 'Floor Name',
        field: 'desc',
        sort: 'asc'
      },
      {
        label: 'Floor Level',
        field: 'level',
        sort: 'asc'
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
    rows: []
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_FLOOR:
      return {
        ...state,
        table_data: action.value
      };

    case actionTypes.GET_FLOOR:
      return {
        ...state,
        floors: action.value
      };
    case actionTypes.GET_ALL_LOCATIONS:
      return {
        ...state,
        locations: action.value
      };

    default:
      return state;
  }
};

export default reducer;
